import './styles.scss'

export type SelectablePreviewProps = {
  imageUrl?: string
  text?: string
  isSelected: boolean
  onSelect: () => void
}

const CLASS_NAME = `selectable-preview`
export const SelectablePreview = (props: SelectablePreviewProps) => {
  return (
    <div className={`${CLASS_NAME}`} onClick={props.onSelect}>
      <div className={`${CLASS_NAME}__container`}>
        {props.imageUrl ? (
          <img
            draggable={false}
            src={props.imageUrl}
            className={`${CLASS_NAME}__image`}
            data-state={props.isSelected ? 'selected' : 'unselected'}
            alt={props.text?.replace('_', ' ')}
          />
        ) : null}
        {props.text && !props.imageUrl ? (
          <div className={`${CLASS_NAME}__text`}>{props.text}</div>
        ) : null}
      </div>

      <input
        onChange={props.onSelect}
        type="checkbox"
        checked={props.isSelected}
        aria-label={props.text?.replace('_', ' ')}
        className={`${CLASS_NAME}__checkbox`}></input>
    </div>
  )
}
